import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const GuidesPage = () => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="mystical-title mb-12">
            Mystical Guides
          </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Newbie Guide Card */}
            <div className="mystical-card group h-full flex flex-col">
              <div className="text-center flex flex-col h-full">
                <div className="mb-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mystical-glow">
                    <span className="text-2xl">🐉</span>
                  </div>
                  <h2 className="mystical-subtitle text-2xl mb-4">
                    Newbie Guide
                  </h2>
                </div>
                
                <p className="mystical-text mb-6 flex-grow">
                  Begin your journey through the mystical streets of Mystveil Township. 
                  Learn the basics of this magical world and discover what it means to be a Veilkin.
                </p>
                
                <div className="mt-auto pt-4">
                  <Link 
                    to="/guide/Newbie" 
                    className="mystical-button w-full text-center block"
                  >
                    Start Your Journey
                  </Link>
                </div>
              </div>
            </div>
            
            {/* MYO Guide Card */}
            <div className="mystical-card group h-full flex flex-col">
              <div className="text-center flex flex-col h-full">
                <div className="mb-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full flex items-center justify-center mystical-glow">
                    <span className="text-2xl">✨</span>
                  </div>
                  <h2 className="mystical-subtitle text-2xl mb-4">
                    MYO Guide
                  </h2>
                </div>
                
                <p className="mystical-text mb-6 flex-grow">
                  Craft your unique identity in the magical realm of Mystveil. 
                  Design your very own Veilkin hatchling and bring them to life!
                </p>
                
                <div className="mt-auto pt-4">
                  <Link 
                    to="/guide/MYO" 
                    className="mystical-button w-full text-center block"
                  >
                    Create Your Veilkin
                  </Link>
                </div>
              </div>
            </div>

            {/* Chips Guide Card */}
            <div className="mystical-card group h-full flex flex-col">
              <div className="text-center flex flex-col h-full">
                <div className="mb-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mystical-glow">
                    <span className="text-2xl">🪙</span>
                  </div>
                  <h2 className="mystical-subtitle text-2xl mb-4">
                    Chips Guide
                  </h2>
                </div>
                
                <p className="mystical-text mb-6 flex-grow">
                  Learn how to earn and track Chips for your Veilkin's progress. 
                  Master the art of progression in this mystical world.
                </p>
                
                <div className="mt-auto pt-4">
                  <Link 
                    to="/guide/Chip" 
                    className="mystical-button w-full text-center block"
                  >
                    Learn About Chips
                  </Link>
                </div>
              </div>
            </div>

            {/* Upgrades Guide Card */}
            <div className="mystical-card group h-full flex flex-col">
              <div className="text-center flex flex-col h-full">
                <div className="mb-6">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-green-500 to-blue-500 rounded-full flex items-center justify-center mystical-glow">
                    <span className="text-2xl">⚡</span>
                  </div>
                  <h2 className="mystical-subtitle text-2xl mb-4">
                    Upgrades Guide
                  </h2>
                </div>
                
                <p className="mystical-text mb-6 flex-grow">
                  Discover the incredible upgrades available for your Veilkin. 
                  Transform your hatchling into a magnificent creature!
                </p>
                
                <div className="mt-auto pt-4">
                  <Link 
                    to="/upgrades" 
                    className="mystical-button w-full text-center block"
                  >
                    Explore Upgrades
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="mt-16">
            <div className="mystical-card max-w-4xl mx-auto text-center">
              <h3 className="mystical-subtitle text-xl mb-6">
                Ready to Begin Your Mystical Journey?
              </h3>
              <p className="mystical-text mb-8">
                Each guide is designed to help you navigate the magical world of Mystveil Township. 
                Whether you're creating your first Veilkin or mastering the chip system, 
                these guides will be your companion on this extraordinary adventure.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/rules" className="mystical-button">
                  Read the Rules
                </Link>
                <Link to="/" className="mystical-button">
                  Return Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default GuidesPage;